/**
 * API base URL: REACT_APP_API_BASE_URL when set, else http://localhost:5000 in development
 * and /api in production (behind nginx). Same rule App.js has always used.
 */
const RAW_BASE = process.env.REACT_APP_API_BASE_URL
  ? process.env.REACT_APP_API_BASE_URL
  : (process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : '/api');

export const API_BASE = RAW_BASE.replace(/\/+$/, '');

/** `${API_BASE}/${path}` without doubled slashes. */
export function apiUrl(path) {
  return `${API_BASE}/${String(path || '').replace(/^\/+/, '')}`;
}

/** Full-size page image URL of a source. */
export function sourceImageUrl(source) {
  if (!source) return '';
  if (source.image_url) return source.image_url;
  return source.image_path ? apiUrl(source.image_path) : '';
}

/** Thumbnail URL of a source (falls back to the full image). */
export function sourceThumbUrl(source, width) {
  if (!source) return '';
  if (source.image_url) return source.image_url;
  if (source.thumb_path) {
    const path = width ? source.thumb_path.replace(/([?&]w=)\d+/, `$1${width}`) : source.thumb_path;
    return apiUrl(path);
  }
  return sourceImageUrl(source);
}

/** Image path of another page of the same manual (page_number is 0-based). */
export function pageImagePath(manualName, pageNumber, width) {
  const base = `pages/${encodeURIComponent(manualName)}/${pageNumber}.jpg`;
  return width ? `${base}?w=${width}` : base;
}
